export default __webpack_public_path__ + "static/media/client28.3bf4100c.png";